import React, { ReactElement } from 'react';

import { Assets } from '../../../utils/assets';
import * as S from './ContentCard.styles';

export type Props = {
  title?: string;
  description?: string;
  link?: string;
  auraColor: 'blue' | 'red';
};

export const ContentCard = (props: Props): ReactElement => {
  const { title, description, link, auraColor } = props;
  return (
    <S.Wrapper>
      <S.Title>{title}</S.Title>
      <S.Description>{description}</S.Description>
      <S.Divider />
      <S.Link href={link} rel="no-follow" target="_blank">
        <S.LinkText>READ ARTICLE</S.LinkText>
        <S.Icon src={Assets.icons.arrowRight.url} />
      </S.Link>
      <S.AuraImage 
        src={ 
          auraColor === 'blue' ? 
          Assets.images.scienceBlueBgAura.url : 
          Assets.images.scienceRedBgAura.url
        }
      />
    </S.Wrapper>
  );
};
